import type { Workflow } from '@fv/models'

import { LoadItemSummary } from '../LoadItemSummary'
import { buildItemSummaryData } from '../load-items/loadItemHelpers'
import type { LoadHandlingUnitFormModel, LoadItemFormModel } from './types'

export const PanelItemSummary = ({
  item,
  workflow,
}: {
  item: LoadItemFormModel | LoadHandlingUnitFormModel
  workflow: Workflow
}) => (
  <div>
    <p className="mt-1 leading-6 border-b border-fv-gray border-dashed mb-2 pb-2 pr-20">
      {item.description || 'Unknown item'}
    </p>
    <LoadItemSummary
      item={buildItemSummaryData(item, workflow)}
      workflow={workflow}
    />
  </div>
)
